import React, { forwardRef } from "react";

import PropTypes from "prop-types";

import { ThemeProvider, createMuiTheme } from "@material-ui/core";

import MaterialTable from "material-table";

import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const theme = createMuiTheme({
  props: {
    MuiPaper: {
      variant: "outlined",
      square: true,
    },
  },
});

theme.overrides = {
  ...theme.overrides,
  MuiPaper: {
    root: {
      border: "0 !important",
    },
  },
};

const CustomTable = (props) => {
  return props.showCompleteTable ? (
    <HelperTable {...props} />
  ) : (
    <ThemeProvider theme={theme}>
      <HelperTable {...props} />
    </ThemeProvider>
  );
};

const HelperTable = ({
  showCompleteTable,
  fromTable,
  data,
  columns,
  getParent,
  defaultAlign,
  defaultSort,
  options,
  ...otherProps
}) => {
  if (defaultAlign) {
    columns = columns.map((x) => ({
      align: defaultAlign,
      ...x,
      // title: defaultAlign == "center" ? "\u2001\u2001" + x.title : x.title,
      cellStyle: {
        textAlign: defaultAlign,
        ...x.cellStyle,
      },
    }));
  }

  if (defaultSort != null) {
    columns = columns.map((x) => ({
      sorting: defaultSort,
      ...x,
    }));
  }

  return (
    <MaterialTable
      {...otherProps}
      elevation={0}
      options={{
        actionsColumnIndex: -1,
        paging: showCompleteTable,
        search: showCompleteTable,
        showTitle: showCompleteTable,
        toolbar: showCompleteTable,
        emptyRowsWhenPaging: false,
        pageSize: 10,
        pageSizeOptions: [10, 20, 50],
        headerStyle: {
          borderBottom: `2px solid ${theme.palette.divider}`,
          backgroundColor: fromTable && theme.palette.grey[200],
          textAlign: defaultAlign,
        },
        rowStyle: (rowData) => {
          const hasParent = getParent != null && getParent(rowData, data) != null;
          const style = {};
          if (fromTable || hasParent) {
            style.backgroundColor = theme.palette.grey[200];
          }
          return style;
        },
        ...options,
      }}
      parentChildData={getParent != null && ((row, rows) => getParent(row, rows))}
      icons={tableIcons}
      columns={columns}
      data={data}
    />
  );
};

CustomTable.propTypes = {
  title: PropTypes.string,
  showCompleteTable: PropTypes.bool,
  fromTable: PropTypes.bool,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  getParent: PropTypes.func,
  defaultAlign: PropTypes.string,
  options: PropTypes.object,
  defaultSort: PropTypes.bool,
};

CustomTable.defaultProps = {
  showCompleteTable: true,
  options: {},
};

export default CustomTable;
